import { Container } from "./styles";
import emailIcon from "../../assets/email-icon.svg";
import phoneIcon from "../../assets/phone-icon.svg"
import { Form } from "../Form/Form";

export function Contact(){

  return(
    <Container id="contato">
      <header>
        <h2>Contacto</h2>
        <p>Puede ponerse en contacto a traves de este sitio, Gmail, Linkedin, Whatsapp o  cualquiera de las  redes sociales.</p>
      </header>
      <div className="contacts">
        <div >
          <img src={emailIcon} alt="Email" />
          <a  href="nicolaseduardoyunes@gmail.com">nicolaseduardoyunes@gmail.com</a>
        </div>
        <div className="disabled">
          <img src={phoneIcon} alt="Email" />
          <a href="tel:+543794012194">(54) 379-4012194</a>
        </div>  
      </div>
      <Form></Form>
    </Container>
  )
}